export default "__VITE_ASSET__a8620caf__"